import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

export default function DeletePhoto(props) {
  const { open, handleClose, onSubmit, loading } = props

  return (
    <DialogComponent
      open={open}
      handleclose={loading ? null : handleClose}
      widthLarge="400px"
      title="¿Desea eliminar esta foto?"
      actions={
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: '15px',
          }}
        >
          <CancelConfirmButtons
            onClickCancel={() => {
              handleClose()
            }}
            onClickSubmit={onSubmit}
            isLoading={loading}
            disabledCancel={loading}
            disabledSubmit={loading}
          />
        </div>
      }
    />
  )
}
